// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"wT-z","inlineTitle":"xT-z","sponsoredAdsWrapper":"yT-z","marketplaceRecosWrapper":"zT-z"};